
<template>
  <v-app id="searchIdit">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Invoice line items</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(iditRecord,i) in searchIdit" :key="i">
           <tr @click="$router.reload('/syst/ref/idit/onIdit/' + iditRecord.idit_encrid)">
             <td>{{iditRecord.idit_nr}}</td>
             <td>{{iditRecord.idittaal_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchIdit: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/idit/searchIdit.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchIdit"
          },
          searchIdit: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchIdit = res.data.searchIdit;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
